exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-buttons[data-v-6a48f39a]{position:absolute;right:0}", ""]);

// exports
